<template>
  <div>
    <TopBar pagetitle="登录" :back-url="url" />
    <div :model="dataForm" class="whiteForm">
      <van-row>
        <van-col span="6">手机号码<span class="mainColor">*</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.phone" placeholder="请输入手机号" style="width:40%" maxlength="11">
          <button :class="buttonEnabel?'fontButton':'fontButton getcode'" style="float:right;margin-top:0em;color:#4a4a4a" @click="sendCode">| {{ sendCodeTitle }}</button>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">验 证 码<span class="mainColor"> *</span></van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.phoneCode" placeholder="请输入验证码">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">生    日</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.birthday" placeholder="请输入生日" readonly @click="showDateSelect=true">
        </van-col>
        <!-- <van-col span="18" offset="6">请输入正确的生日</van-col> -->
      </van-row>
      <van-row>
        <van-col span="24" class="center redlink">
          <van-checkbox v-model="checked" style="font-weight:700">我已阅读并同意<span class="MainfontLink" @click="readFile">用户服务协议</span></van-checkbox>
        </van-col>
      </van-row>
      <van-button type="info" size="large" :loading="regPhoneLoading" loading-text="登录中..." @click="regPhone">登录</van-button>

      <van-popup v-model="showDateSelect" position="bottom">
        <van-datetime-picker
          v-model="birthday1"
          type="date"
          :max-date="maxDate"
          :min-date="minDate"
          :formatter="formatter"
          @confirm="onDateConfirm"
          @cancel="onDateCancel"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Field, Button, Checkbox, DatetimePicker, Popup, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { initPage, formatDate, getUrlKey, MyNotify } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      showDateSelect: false,
      minDate: new Date(1900, 1, 1),
      maxDate: new Date(),
      dataForm: {
        // phone: '18198218602',
        // phoneCode: '123456',
        phone: '',
        phoneCode: '',
        birthday: '',
        trueBind: false,
        phoneArea: '86'
      },
      birthday1: new Date(1990, 1, 1),
      checked: true,
      totalTime: -1,
      buttonEnabel: true,
      sendCodeTitle: '获取验证码',
      regPhoneLoading: false,
      url: '/home/index'
    }
  },
  watch: {
    birthday1(value) {
      this.dataForm.birthday = formatDate(value, 'yyyy-MM-dd')
    }
  },
  created() {
    initPage(false)
    var cardId = getUrlKey('cardId')
    if (cardId !== null) {
      this.cardId = cardId
    }
    var backUrl = getUrlKey('backUrl')
    if (backUrl !== null) {
      this.url = backUrl
    }
    // request({
    //   url: '/user/Login',
    //   method: 'post'
    // }).then(Response => {
    //   this.$router.replace('/t')
    // })
  },
  activated() {
    this.minDate = new Date(1900, 1, 1)
  },
  methods: {
    readFile() {
      this.$router.replace('/home/staticPage/regprotocol?backurl=/users/regPhone')
    },
    sendCode() {
      if (this.totalTime >= 0) {
        return
      }
      if (this.dataForm.phone.trim().length !== 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      // var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/
      var reg = /^1\d{10}$/
      if (!reg.test(this.dataForm.phone.trim())) {
        MyNotify('info', '请输入正确的11位手机号码')
        return
      }
      this.buttonEnabel = false
      request({
        url: '/user/SendRegSms',
        method: 'post',
        data: {
          phoneArea: '86',
          phone: this.dataForm.phone,
          hashCode: '123',
          type: 'REG'
        }
      }).then(Response => {
        if (Response.success) {
          this.totalTime = Response.data
          this.sendCodeTitle = this.totalTime + 's后重发' // 这里解决60秒不见了的问题
          const clock = window.setInterval(() => {
            this.totalTime--
            this.sendCodeTitle = this.totalTime + 's后重发'
            if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
              window.clearInterval(clock)
              this.sendCodeTitle = '获取验证码'
              this.buttonEnabel = true
            }
          }, 1000)
          MyNotify('success', '验证码发送成功!')
        } else {
          this.buttonEnabel = true
        }
      })
    },
    regPhone() {
      if (!this.checked) {
        MyNotify('info', '请阅读并同意用户服务协议')
        return
      }
      if (this.dataForm.phone.trim().length !== 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      var reg = /^1\d{10}$/
      if (!reg.test(this.dataForm.phone.trim())) {
        MyNotify('info', '请输入11位手机号码')
        return
      }

      if (this.dataForm.phoneCode.trim().length < 4) {
        MyNotify('info', '请输入验证码')
        return
      }
      this.regPhoneLoading = true
      var postdata = JSON.parse(JSON.stringify(this.dataForm))
      request({
        url: '/user/regPhone',
        method: 'post',
        data: postdata
      }).then(Response => {
        this.regPhoneLoading = false
        if (Response.success) {
          this.$store.dispatch('user/resetToken', Response.data)
          // MyNotify('success', '登录成功!')
          if (Response.data.bindSSI) {
            if (this.url) {
              this.$router.replace(this.url)
            } else {
              this.$router.replace('/')
            }
          } else {
            this.$router.replace('/users/bindSSI?url=' + this.url)
          }
        } else if (Response.code === 2016) {
          // 如果手机号码被占用，提示是否覆盖绑定
          Dialog.confirm({
            title: '手机号码已被占用',
            message: '该手机号码已被其他微信用户绑定,是否要覆盖绑定?\r\n(一旦绑定后其他用户将会被解除绑定)',
            cancelButtonText: '覆盖绑定',
            confirmButtonText: '取消'
          }).then(() => {
            // 取消 无操作
          }).catch(() => {
            // 覆盖绑定
            this.dataForm.trueBind = true
            this.regPhone()
            this.dataForm.trueBind = false
          })
        }
      })
    },

    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    formatDate,
    onDateConfirm() {
      this.dataForm.birthday = formatDate(this.birthday1, 'yyyy-MM-dd')
      this.showDateSelect = false
    },
    onDateCancel() {
      this.showDateSelect = false
      this.dataForm.birthday = undefined
    }

  }

}
</script>

<style scoped>

</style>
